import Cookies from 'js-cookie';
import request from 'superagent';
import {getDeviceSource} from 'utils/deviceSource';

export const getAuthParams = () => {
  const user = localStorage.getItem('user') || Cookies.get('user');
  return user && JSON.parse(user);
};

export const clearAuthState = () => {
  try {
    localStorage.removeItem('user');
  } catch { // do nothing
  }
  try {
    Cookies.remove('TP24ID');
    Cookies.remove('user');
  } catch {
    // do nothing
  }
};

export const handleUnauthorized = () => {
  clearAuthState();
};

export const getSessionToken = () => (getAuthParams()?.session_token ?? null);
export const getRefreshToken = () => (getAuthParams()?.refreshToken ?? null);
export const getEmail = () => (getAuthParams()?.email ?? null);

export const persistUser = (partial) => {
  try {
    const current = getAuthParams() || {};
    const state = {...current, ...partial};
    localStorage.setItem('user', JSON.stringify(state));
    if (state.session_token) {
      Cookies.set('TP24ID', state.session_token);
    }
    try {
      Cookies.set('user', JSON.stringify(state));
    } catch {
      // do nothing
    }
  } catch {
    // do nothing
  }
};

export const refreshSessionToken = async () => {
  try {
    const rt = getRefreshToken();
    const email = getEmail();
    if (!rt) return false;

    const {body, status} = await request
      .post('/api/users/login')
      .set({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Device-Source': getDeviceSource()
      })
      .send({
        email,
        provider: 'brand',
        providerUserID: '',
        action: 'refreshToken',
        refreshToken: rt
      })
      .ok(({status}) => [200, 201, 400, 404].includes(status));

    if (![200, 201].includes(status)) {
      clearAuthState();
      return false;
    }

    const {session_token, refreshToken: returnedRefreshToken} = body?.response?.result || {};
    if (session_token && returnedRefreshToken) {
      persistUser({session_token, refreshToken: returnedRefreshToken});
      return true;
    }
  } catch {
    clearAuthState();
  }
  return false;
};

export const withRefreshRetry = async (makeRequest) => {
  const first = await makeRequest();
  if (first?.status !== 401) return first;
  const refreshed = await refreshSessionToken();
  if (refreshed) {
    return makeRequest();
  }
  handleUnauthorized();
  return first;
};
